import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GoogleAnalyticsEventsService } from '../../../services/google-analytics-events.service';
import { IcortexDeploymentHubUrlService } from '../../../services/icortex-deployment-hub-url.service';
import { IcortexLocalizedPathService } from '../../../services/icortex-localized-path.service';
import { wfImage as wfImageFn } from '../wf-static';

@Component({
  standalone: true,
  selector: 'app-wf-footer',
  imports: [ RouterModule ],
  templateUrl: './wf-footer.component.html'
})
export class WfFooterComponent {

  readonly wfImage = wfImageFn;

  private readonly icortexLocalizedPathService = inject( IcortexLocalizedPathService );

  private readonly googleAnalyticsEventsService = inject( GoogleAnalyticsEventsService );

  private readonly icortexDeploymentHubUrlService = inject( IcortexDeploymentHubUrlService );

  sendGAEvent( category: string, action: string, label: string, value?: number ): void {

    this.googleAnalyticsEventsService.emitEvent( category, action, label, value );
  }

  protected localizedPath( path: string ): string {

    return this.icortexLocalizedPathService.getLocalizedPath( path );
  }


  /**
   * @description External Deployment Hub URL; Spanish site uses /help/es.
   * @return Full help center URL for the active language.
   */
  protected deploymentHubHref(): string {

    return this.icortexDeploymentHubUrlService.getDeploymentHubHref();
  }

}
